// actions.js
import * as actionTypes from './actionsTypes';

export const setValue = (newValue) => ({
  type: actionTypes.SET_VALUE,
  payload: newValue
});

export const setSansEmail = (newSansEmail) => ({
  type: actionTypes.SET_SANS_EMAIL,
  payload: newSansEmail
});

export const setEnAttenteValidation = (newValue) => ({
  type: actionTypes.SET_EN_ATTENTE_VALIDATION,
  payload: newValue
});

export const setStatut = (newStatut) => ({
  type: actionTypes.SET_STATUT,
  payload: newStatut
});

export const setType = (newType) => ({
  type: actionTypes.SET_TYPE,
  payload: newType
});

export const setCompteOuvert = (newCompteOuvert) => ({
  type: actionTypes.SET_COMPTE_OUVERT,
  payload: newCompteOuvert
});

export const setCourrier = (newCourrier) => ({
  type: actionTypes.SET_COURRIER,
  payload: newCourrier
});

export const setCreeLe = (newCreeLe) => ({
  type: actionTypes.SET_CREE_LE,
  payload: newCreeLe
});

export const setDerniereSouscription = (newValue) => ({
  type: actionTypes.SET_DERNIERE_SOUSCRIPTION,
  payload: newValue
});
export const setCurrentPage = (newCurrentPage) => ({
    type: actionTypes.SET_CURRENT_PAGE,
    payload: newCurrentPage
  });
  export const setSelectedOptions = (newSelectedOptions) => ({
    type: actionTypes.SET_SELECTED_OPTIONS,
    payload: newSelectedOptions
  });
  export const setSortField = (newSortField) => ({
    type: actionTypes.SET_SORT_FIELD,
    payload: newSortField
  });
  export const setOrder = (newOrder) => ({
    type: actionTypes.SET_ORDER,
    payload: newOrder
  });
  